/* SK Search Expand — normaliza, expande y enruta la query de busqueda.

   Preparado para el catalogo actual de SOKA. Tres mapas (editar aqui para ampliar):
   - FIX:      grafias vascas / typos / sin-espacio -> termino canonico. Aplica en
               dropdown Y en /search.
   - BRIDGE:   solo dropdown -> consulta que el predictive SI resuelve. El predictive
               (suggest) solo indexa titulo+tipo+proveedor, NO tags en texto libre,
               pero SI acepta el calificador `tag:`. Lo usamos para categorias que el
               dropdown no encontraria (vino, oveja, jamon...).
   - REDIRECT: en Enter/submit, terminos de categoria -> su coleccion. URL limpia y
               solo esos productos (en /search algunas categorias se cuelan productos
               de otras, p.ej. "vino" traia sidra/pacharan).

   Aplica en: fetch del predictive (/search/suggest), tecla Enter y submit de los forms.
   Funciona en TODOS los buscadores (header desktop, header mobile, drawer). */
(function () {
  'use strict';

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .trim().replace(/\s+/g, ' ');
  }

  /* Variante / typo / sin-espacio -> termino canonico (dropdown Y /search) */
  var FIX = {
    'chacoli': 'txakoli', 'chakoli': 'txakoli', 'xakoli': 'txakoli', 'xacoli': 'txakoli',
    'txacoli': 'txakoli', 'chacolina': 'txakoli', 'txakolina': 'txakoli', 'getariako': 'txakoli',
    'bakalao': 'bacalao', 'bakailao': 'bacalao', 'bacalada': 'bacalao',
    'vinoblanco': 'vino blanco', 'vinotinto': 'vino tinto',
    'patxaran': 'pacharan',
    'antxoa': 'anchoa', 'antxoas': 'anchoa',
    'txuleta': 'chuleta', 'txuleton': 'chuleton',
    'hanburguesa': 'hamburguesa', 'burguer': 'hamburguesa', 'burger': 'hamburguesa',
    'kokotxa': 'cococha', 'kokotxas': 'cococha', 'kokotza': 'cococha',
    'sagardoa': 'sidra', 'sagardo': 'sidra',
    'gazta': 'queso', 'idiazaval': 'idiazabal',
    'buey': 'vaca', 'vacuno': 'vaca'
  };

  /* Solo dropdown: categoria -> consulta que el predictive SI resuelve.
     El "resultados para X" del dropdown es visually-hidden (no se ve). */
  var BRIDGE = {
    'vino': 'tag:Vino', 'vinos': 'tag:Vino', 'vino blanco': 'tag:Vino', 'vino tinto': 'tag:Vino',
    'vino rosado': 'tag:Vino', 'vino rosa': 'tag:Vino',
    'oveja': 'tag:"Queso de oveja"', 'queso de oveja': 'tag:"Queso de oveja"',
    'jamon': 'tag:Jamón', 'jamones': 'tag:Jamón', 'iberico': 'tag:Jamón', 'ibericos': 'tag:Jamón'
  };

  /* Enter/submit: termino de categoria -> su coleccion (URL limpia, productos exactos) */
  var REDIRECT = {
    'carne': '/collections/carnes', 'carnes': '/collections/carnes',
    'vaca': '/collections/vaca', 'ternera': '/collections/ternera',
    'pollo': '/collections/pollo-lumagorri', 'pollo lumagorri': '/collections/pollo-lumagorri', 'lumagorri': '/collections/pollo-lumagorri',
    'queso': '/collections/quesos', 'quesos': '/collections/quesos',
    'queso idiazabal': '/collections/queso-idiazabal', 'idiazabal': '/collections/queso-idiazabal',
    'queso de oveja': '/collections/queso-de-oveja', 'oveja': '/collections/queso-de-oveja',
    'queso agour': '/collections/queso-agour', 'agour': '/collections/queso-agour',
    'queso de cabra': '/collections/queso-de-cabra', 'cabra': '/collections/queso-de-cabra',
    'queso azul': '/collections/queso-azul',
    'conserva': '/collections/conservas', 'conservas': '/collections/conservas',
    'conservas del mar': '/collections/conservas-del-mar',
    'conservas de la tierra': '/collections/conservas-de-la-tierra',
    'conservas de carne': '/collections/conservas-de-carne',
    'embutido': '/collections/embutidos-gourmet', 'embutidos': '/collections/embutidos-gourmet',
    'jamon': '/collections/jamon', 'jamones': '/collections/jamon', 'iberico': '/collections/jamon', 'ibericos': '/collections/jamon',
    'lomo': '/collections/lomo', 'chorizo': '/collections/chorizo',
    'panceta': '/collections/panceta', 'salchichon': '/collections/salchichon',
    'bacalao': '/collections/bacalao-gourmet',
    'bebida': '/collections/bebidas-gourmet', 'bebidas': '/collections/bebidas-gourmet',
    'txakoli': '/collections/txakoli', 'sidra': '/collections/sidra',
    'vino': '/collections/vino', 'vinos': '/collections/vino', 'vino blanco': '/collections/vino', 'vino tinto': '/collections/vino', 'vino rosado': '/collections/vino',
    'pacharan': '/collections/pacharan',
    'despensa': '/collections/despensa-gourmet',
    'dulce': '/collections/dulces-tradicionales', 'dulces': '/collections/dulces-tradicionales',
    'cesta': '/collections/cestas-y-lotes', 'cestas': '/collections/cestas-y-lotes',
    'lote': '/collections/cestas-y-lotes', 'lotes': '/collections/cestas-y-lotes', 'cestas y lotes': '/collections/cestas-y-lotes'
  };

  /* Corrige variantes. Frase completa o token a token (ej. "gazta idiazabal"). */
  function canonicalize(q) {
    var n = norm(q);
    if (FIX[n]) return FIX[n];
    return n.split(' ').map(function (t) { return FIX[t] || t; }).join(' ');
  }

  function bridge(q) { return BRIDGE[norm(q)] || q; }

  /* Para la pagina /search: anade comodin al ultimo termino -> prefix matching.
     Shopify no casa prefijos cortos ("car" no encuentra carne) salvo con "car*".
     No tocar si ya lleva *, comillas o un calificador (tag:). */
  function wildcardize(q) {
    q = (q || '').trim();
    if (!q || q.indexOf('*') !== -1 || q.indexOf(':') !== -1 || q.indexOf('"') !== -1) return q;
    return q.replace(/(\S+)\s*$/, '$1*');
  }

  /* ---- 1) Dropdown: interceptar el fetch a /search/suggest y reescribir q ---- */
  var _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function (input, init) {
      try {
        var urlStr = (typeof input === 'string') ? input : (input && input.url);
        if (urlStr) {
          var u = new URL(urlStr, location.origin);
          if (u.pathname.endsWith('/search/suggest') && u.searchParams.has('q')) {
            var orig = u.searchParams.get('q') || '';
            var expanded = bridge(canonicalize(orig));
            if (expanded && norm(expanded) !== norm(orig)) {
              u.searchParams.set('q', expanded);
              input = (typeof input === 'string') ? u.toString() : new Request(u.toString(), input);
            }
          }
        }
      } catch (e) { /* nunca romper el fetch original */ }
      return _fetch.call(this, input, init);
    };
  }

  /* ---- 2) /search: corregir, redirigir categorias o navegar con type=product ----
     Navegamos nosotros para garantizar SIEMPRE type=product (asi el contador de la
     pagina = nº de productos) + el comodin del ultimo termino. */
  function goToSearch(form, term) {
    var base = (form && form.getAttribute('action')) || '/search';
    var u = new URL(base, location.origin);
    u.searchParams.set('q', wildcardize(term));
    u.searchParams.set('type', 'product');
    window.location.href = u.toString();
  }

  /* Enter en el predictive navega por JS leyendo input.value -> lo tratamos en captura */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var el = e.target;
    if (!el || el.name !== 'q' || (el.type !== 'search' && el.type !== 'text')) return;
    /* si hay un resultado del predictive seleccionado, dejar que navegue al producto */
    var comp = el.closest('predictive-search-component');
    if (comp && comp.querySelector('[aria-selected="true"]')) return;
    var fixed = canonicalize(el.value);
    if (!fixed.trim()) return;
    e.preventDefault();
    e.stopPropagation();
    var dest = REDIRECT[norm(fixed)];
    if (dest) { window.location.href = dest; return; }
    goToSearch(el.closest('form'), fixed);
  }, true);

  /* Submit del form (boton de busqueda) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!/\/search/.test(form.getAttribute('action') || '')) return;
    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value.trim()) return;
    var fixed = canonicalize(input.value);
    e.preventDefault();
    var dest = REDIRECT[norm(fixed)];
    if (dest) { window.location.href = dest; return; }
    goToSearch(form, fixed);
  }, true);

  /* ---- 3) En la pagina /search, ocultar el comodin del texto visible ---- */
  (function cleanupWildcardDisplay() {
    if (!/\/search$/.test(location.pathname)) return;
    var strip = function (s) { return (s || '').replace(/\*+\s*$/, ''); };
    document.querySelectorAll('.sk-search__input').forEach(function (i) {
      if (i.value) i.value = strip(i.value);
    });
    document.querySelectorAll('.sk-search__count strong').forEach(function (s) {
      s.textContent = strip(s.textContent);
    });
    if (document.title.indexOf('*') !== -1) document.title = document.title.replace(/\*+/g, '');
  })();
})();
